import { Loader2 } from 'lucide-react';

interface LoadingStateProps {
  title?: string;
  message?: string;
}

export function PolicyApplicationLoadingState({
  title,
  message,
}: LoadingStateProps) {
  return (
    <div className="flex min-h-screen items-center justify-center bg-primary-50">
      <div className="text-center">
        <div className="mb-4 flex justify-center">
          <Loader2 className="h-12 w-12 animate-spin text-primary-500" />
        </div>
        <h2 className="mb-2 text-xl font-semibold text-gray-900">
          {title || 'Loading Policy Application'}
        </h2>
        <p className="text-gray-600">
          {message || 'Please wait while we retrieve your application details...'}
        </p>
      </div>
    </div>
  );
}